import { Box, Flex, IconFont, Text } from '@byecode/ui'
import { mergeRefs } from '@lighthouse/tools'
import React from 'react'
import styled from 'styled-components'

import { TooltipText } from '../TooltipText'

export interface CheckButtonProps {
    label?: string
    width?: string
    isSuffixIcon?: boolean
    isBackground?: boolean
    active?: boolean
    extra?: React.ReactNode
    onClick?: () => void
}

const SCxCheckButton = styled.div<{ width: string }>`
    flex-shrink: 0;
    /* min-width: 80px; */
    /* max-width: 168px; */
    width: ${({ width }) => width};
    padding: 0 6px;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 24px;
    line-height: 24px;
    border-radius: 5px;
    text-align: center;
    font-size: var(--font-size-normal);
    cursor: pointer;

    iconpark-icon {
        vertical-align: -4px;
    }
`

export const CheckButton = React.forwardRef<HTMLDivElement, CheckButtonProps>(
    ({ label, active, width = 'auto', isSuffixIcon, isBackground, onClick }, ref) => {
        return (
            <TooltipText
                title={label}
                render={toolTipRef => (
                    <SCxCheckButton
                        data-filter-input
                        data-filter-active={!!active}
                        data-filter-disabled={false}
                        ref={mergeRefs([toolTipRef, ref])}
                        onClick={onClick}
                        width={width}
                    >
                        <Text>{label}</Text>
                        {isSuffixIcon && (
                            <Flex data-filter-icon alignItems="center">
                                <IconFont size={16} type="ArrowDownSmall" />
                            </Flex>
                        )}
                    </SCxCheckButton>
                )}
            />
        )
    }
)
